import vue from "@/eventBus";
import { Amplify } from "aws-amplify";
import api from "@/api";
import store from "@/vuex/store";
export class AWSAmplify {
  async configureAWSAmplify() {
    await api.getCognitoPoolInfo().then(response => {
      let decryptedPoolInfo = vue.CryptoJS.AES.decrypt(response.body.data, `${process.env.VUE_APP_COGNITO_API_SECRET}`).toString(vue.CryptoJS.enc.Utf8);
      decryptedPoolInfo = JSON.parse(decryptedPoolInfo);
      store.dispatch("setSSOPoolClient", decryptedPoolInfo.ssoPoolClient);
      //Set the SSO loginURL to use for redirection in case of error "user already found"
      store.dispatch("setSSOLoginURL", decryptedPoolInfo.ssoLoginURL);
      try {
        Amplify.configure({
          Auth: {
            region: decryptedPoolInfo.region,
            userPoolId: decryptedPoolInfo.poolId,
            userPoolWebClientId: decryptedPoolInfo.poolClientId,
            authenticationFlowType: "USER_PASSWORD_AUTH"
          }
        });
      } catch (e) {
        throw new Error(e);
      }
    });
  }

  async configureAWSAmplifyParticipant() {
    await api.getCognitoPoolParticipantInfo().then(response => {
      let decryptedPoolInfo = vue.CryptoJS.AES.decrypt(response.body.data, `${process.env.VUE_APP_COGNITO_API_SECRET}`).toString(vue.CryptoJS.enc.Utf8);
      decryptedPoolInfo = JSON.parse(decryptedPoolInfo);
      store.dispatch("setSSOPoolClient", decryptedPoolInfo.ssoPoolClient);
      //Set the SSO loginURL to use for redirection in case of error "user already found"
      store.dispatch("setSSOLoginURL", decryptedPoolInfo.ssoLoginURL);
      try {
        Amplify.configure({
          Auth: {
            region: decryptedPoolInfo.region,
            userPoolId: decryptedPoolInfo.poolId,
            userPoolWebClientId: decryptedPoolInfo.poolClientId
          }
        });
      } catch (e) {
        throw new Error(e);
      }
    });
  }
}
